import { AfterViewInit, Component, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { NgbDateStruct, NgbPaginationConfig } from '@ng-bootstrap/ng-bootstrap';
import {
  NgbDateAdapter,
  NgbDateNativeAdapter,
} from '@ng-bootstrap/ng-bootstrap';
import { jwtDecode } from 'jwt-decode';
import { JWTContent } from 'src/app/app.component';
import { OrderService } from 'src/app/shared/services/order.service';
import { PaymentService } from 'src/app/shared/services/payment.service';
import { SuscripcionService } from 'src/app/shared/services/suscripcion.service';
import { environment } from 'src/environments/environment';

export interface PaymentsData {
  id: number;
  idReferencia: number;
  idExternoOrden: string;
  tipoReferencia: string;
  fechaPagado: Date;
  fechaCreado: Date;
  pasarelaPago: PasarelaPago;
  estadoPago: string;
  importe: number;
  importeGravado: number;
  codigoAutorizacion: string;
  moneda: Moneda;
}

export interface PasarelaPago {
  id: number;
  idExterno: string;
  nombre: string;
}

export interface Moneda {
  id: number;
  codigo: string;
  moneda: string;
  simbolo: string;
}

@Component({
  selector: 'app-orders',
  templateUrl: './orders.page.html',
  styleUrls: ['./orders.page.scss'],
  providers: [
    NgbPaginationConfig,
    { provide: NgbDateAdapter, useClass: NgbDateNativeAdapter },
    // { provide: NgbDateParserFormatter, useClass: NgbDateParserFormatter }
  ],
})
export class OrdersPage {
  pageIndex = 1;
  pageSize = 10;
  total!: number;
  data: PaymentsData[] = [];

  displayedColumns: string[] = [
    'paymentNumber',
    'reference',
    'dateCreated',
    'datePayment',
    'status',
    'value',
    'gateway',
    'authorization',
  ];

  estado!: string;
  tipo!: string;
  rangoDias!: string;
  fechaInicio!: NgbDateStruct;
  fechaFin!: NgbDateStruct;
  hasAccess = false;

  @ViewChild('paginator') paginator: any; // Replace 'MatPaginator' with 'any'
  @ViewChild('sort') sort: any; // Replace 'MatSort' with 'any'

  constructor(
    public orderService: OrderService,
    private paginationConfig: NgbPaginationConfig,
  ) {
    paginationConfig.boundaryLinks = true; // Configure pagination options
    paginationConfig.pageSize = this.pageSize;
  }

  async ngOnInit(): Promise<void> {}

  buscar() {
    this.orderService
      .getAll(
        this.pageSize,
        (this.pageIndex - 1) * this.pageSize,
        this.fechaInicio,
        this.fechaFin,
        this.rangoDias,
        this.estado,
        this.tipo,
      )
      .subscribe(resp => {
        this.data = resp.paymentOrders;
        this.total = resp.total;
      });
  }

  paginar(paginator: any) {
    this.pageIndex = paginator;
    this.buscar();
  }

  pagar(invoice: any) {
    this.orderService.pagarOrdenPago(invoice['id']).subscribe(
      response => {
        if (response != null && response !== undefined && response !== '') {
          if (response === 'EXITO') {
            console.log('RESPONSE', response);
            //this.wizzard.selected.completed = true;
            //this.wizzard.next();
          } else {
            document.open('text/html');
            document.write(response);
            document.close();
          }
        }
      },
      error => {
        //this.config = new MatSnackBarConfig();
        //this.config.duration = 5000;
        const mensaje = 'Hubo un error al pagar la factura, Intente mas tarde';
        //this.snackbar.open(mensaje, 'Cerrar', this.config);
      },
    );
  }
}
